import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PublicSignSession, PurchaseOrder } from '@models/resources/purchase-order.model';

/**
 * Customer-seitige Kaufauftrag-Actions (Sprint 9, ADR-011).
 *
 * Method-Mapping (BE `Customer\MePurchaseOrderController`, /me-Group):
 * - `get(id)`                    → `GET  /me/purchase-orders/{id}`
 * - `chooseIdentityMethod(...)`  → `POST /me/purchase-orders/{id}/identity-method`
 * - `uploadIdDocuments(...)`     → `POST /me/purchase-orders/{id}/id-documents`
 * - `startSignature(id)`         → `POST /me/purchase-orders/{id}/signature`
 * - `submitSignature(id, png)`   → `POST /me/purchase-orders/{id}/signature/submit`
 * - `requestSignLink(id)`        → `POST /me/purchase-orders/{id}/signature/email`
 * - `couponUrl(id)` / `pdfUrl(id)` liefern direkte Download-URLs.
 *
 * In-App-Signatur (ADR-011, EES) — öffentlicher, token-gesicherter Pfad
 * (E-Mail / QR, kein Login):
 * - `getPublicSignSession(token)`   → `GET  /sign/{token}`
 * - `publicSignPdf(token)`          → `GET  /sign/{token}/pdf`
 * - `submitPublicSignature(token,…)`→ `POST /sign/{token}`
 */
export interface PurchaseOrderFacade {
  get(id: number): Observable<PurchaseOrder>;
  chooseIdentityMethod(id: number, method: 'video' | 'post'): Observable<PurchaseOrder>;
  uploadIdDocuments(id: number, front: File, back: File): Observable<PurchaseOrder>;
  startSignature(id: number): Observable<PurchaseOrder>;
  /** Authentifizierter (mobiler) Submit der gezeichneten Unterschrift. */
  submitSignature(id: number, png: Blob): Observable<PurchaseOrder>;
  /** „Signier-Link per E-Mail" — mintet frischen Token + mailt den Link. */
  requestSignLink(id: number): Observable<PurchaseOrder>;
  couponUrl(id: number): string;
  pdfUrl(id: number): string;

  /** Public-Signierseite: Session-Summary (nur Token). */
  getPublicSignSession(token: string): Observable<PublicSignSession>;
  /** Public-Signierseite: unsigniertes PDF als Blob (nur Token). */
  publicSignPdf(token: string): Observable<Blob>;
  /** Public-Signierseite: Unterschrift einreichen (nur Token). */
  submitPublicSignature(token: string, png: Blob): Observable<PublicSignSession>;
}

export const PURCHASE_ORDER_FACADE = new InjectionToken<PurchaseOrderFacade>(
  'PurchaseOrderFacade',
);
